import $http from '@/api';

export default {
  async fetchClipboard(id) {
    const { data } = await $http.get(`/api/clipboard/${id}`);
    return data;
  },
  async saveClipboard(id, data) {
    return $http.put(`/api/clipboard/${id}`, { data });
  },
};
